import { Loader } from '@googlemaps/js-api-loader'

export const mapLoader = new Loader({
    apiKey: import.meta.env.VITE_GOOGLE_MAP_KEY ?? '',
    version: 'weekly'
  })
